import moment from "moment";
import {
  TwelveDataStockTimeSeries,
  TimeSeries,
  NewStockParametersForTimeSeries,
} from "../reducers/stocks/types";
import { AppDispatch, AppThunk } from "../store";
import { PayloadAction } from "@reduxjs/toolkit";

export type FormattedStockData = {
  open: string[];
  time: moment.Moment[];
};

export const formatData = (
  stock: TwelveDataStockTimeSeries
): FormattedStockData => {
  const open = stock.values.map((timeSeries: TimeSeries) => timeSeries.open);
  const time = stock.values.map((timeSeries: TimeSeries) =>
    moment(timeSeries.datetime)
  );
  return { open, time };
};

export const adjustRange = (
  interval: string,
  outputSize: string,
  dispatch: AppDispatch,
  setInterval: (payload: string) => PayloadAction<string>,
  twelveDataTimeSeries: (
    stock?: NewStockParametersForTimeSeries,
    search?: string
  ) => AppThunk,
  twelveDataQuote: (
    stock?: NewStockParametersForTimeSeries,
    search?: string
  ) => AppThunk,
  stock: string
): void => {
  const stockObjectOptions: NewStockParametersForTimeSeries = {
    searchSymbol: stock,
    interval,
    outputSize,
  };
  dispatch(setInterval(interval));
  dispatch(
    twelveDataTimeSeries(stockObjectOptions, stockObjectOptions.searchSymbol)
  );
  dispatch(
    twelveDataQuote(stockObjectOptions, stockObjectOptions.searchSymbol)
  );
};
